import { render } from "./Farms.vue?vue&type=template&id=afa866e0&ts=true"
import script from "./Farms.vue?vue&type=script&lang=ts"
export * from "./Farms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__